import { create } from 'zustand'
import { PermissionsAdapter } from '../../utils/permission'

type PermissionState = {
    hasLocationPermission: boolean
    hasNotificationPermission: boolean
    hasCameraPermission: boolean
    hasMediaLibraryPermission: boolean

    checkPermissions: () => Promise<void>

    requestLocationPermission: () => Promise<boolean>
    requestNotificationPermission: () => Promise<boolean>
    requestCameraPermission: () => Promise<boolean>
    requestMediaLibraryPermission: () => Promise<boolean>

    updatePermissions: (location: boolean, notification: boolean, camera: boolean, mediaLibrary: boolean) => void

    locationEnabled: boolean,
    setLocationEnabled: (enabled: boolean) => void
}

export const usePermissionStore = create<PermissionState>((set, get) => ({
    locationEnabled: false,
    setLocationEnabled: (enabled) => set({ locationEnabled: enabled }),

    hasLocationPermission: false,
    hasNotificationPermission: false,
    hasCameraPermission: false,
    hasMediaLibraryPermission: false,


    checkPermissions: async () => {
        const locationGranted = await PermissionsAdapter.checkLocationPermission();
        const notificationGranted = await PermissionsAdapter.checkNotificationPermission();
        const cameraGranted = await PermissionsAdapter.checkCameraPermission();
        const mediaLibraryGranted = await PermissionsAdapter.checkMediaLibraryPermission();
        
        set({
            hasLocationPermission: locationGranted === 'granted',
            hasNotificationPermission: notificationGranted === 'granted',
            hasCameraPermission: cameraGranted === 'granted',
            hasMediaLibraryPermission: mediaLibraryGranted === 'granted',
        });
    },


    requestLocationPermission: async () => {
        const granted = await PermissionsAdapter.getRequestLocationPermission()
        set({ hasLocationPermission: granted === 'granted' })
        return granted === 'granted'
    },
    requestNotificationPermission: async () => {
        const granted = await PermissionsAdapter.getRequestNotificationPermission()
        set({ hasNotificationPermission: granted === 'granted' })
        return granted === 'granted'
    },
    requestCameraPermission: async () => {
        const granted = await PermissionsAdapter.getRequestCameraPermission()
        set({ hasCameraPermission: granted === 'granted' })
        return granted === 'granted'
    },
    requestMediaLibraryPermission: async () => {
        const granted = await PermissionsAdapter.getRequestImagePickerPermission()
        set({ hasMediaLibraryPermission: granted === 'granted' })
        return granted === 'granted'
    },


    updatePermissions: (location: boolean, notification: boolean, camera: boolean, mediaLibrary: boolean) => {
        set({
            hasLocationPermission: location ? location : get().hasLocationPermission,
            hasNotificationPermission: notification ? notification : get().hasNotificationPermission,
            hasCameraPermission: camera ? camera : get().hasCameraPermission,
            hasMediaLibraryPermission: mediaLibrary ? mediaLibrary : get().hasMediaLibraryPermission,
        })
    }
}))
